import { render, staticRenderFns } from "./BaseWrapper.vue?vue&type=template&id=1921172c&scoped=true"
import script from "./BaseWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseWrapper.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BaseWrapper.vue?vue&type=style&index=0&id=1921172c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1921172c",
  null
  
)

export default component.exports